module.exports = __webpack_public_path__ + "static/media/CTLA_7-216w.e7a33272.jpg";